import { z } from "zod";
import { CustomFormFieldValidation } from "@shared/types";

interface CustomValidations {
  partnerPlan: CustomFormFieldValidation;
}

export const mapIntegrationPlanSchema = ({
  partnerPlan,
}: CustomValidations) => {
  return z.object({
    plan: z.number().min(1),
    plan_slug_integration: z.string().optional(),
    plan_slug_integration_list: z.string().optional(),
    price_integration: z.any().optional().nullable(),
    price_from: z.preprocess((v) => (v === "" || v == null ? null : Number(v)), z.number().min(0).nullable().optional()),
    price_to: z.preprocess((v) => (v === "" || v == null ? null : Number(v)), z.number().min(0).nullable().optional()),
  }).refine(
    (data) => {
      const hasName = !!data.plan_slug_integration;
      const hasList = !!data.plan_slug_integration_list;
      return partnerPlan.validate(hasName, hasList);
    },
    {
      message: partnerPlan.errorMessage,
      path: ["plan_slug_integration"]
    }
  );
};

export type MapIntegrationPlanFormValues = z.infer<ReturnType<typeof mapIntegrationPlanSchema>>;
